import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { vscDarkPlus } from 'react-syntax-highlighter/dist/esm/styles/prism';
import { MdContentCopy } from 'react-icons/md';
import toast from 'react-hot-toast';

const ChatMessage = ({ message }) => {
  const isOwn = message.role === 'user';
  
  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    toast.success('Code copied!');
  };

  return (
    <div className={`messageWrapper ${isOwn ? 'own' : 'other'}`}>
      <div className="messageHeader">
        <span className="messageSender">{isOwn ? 'You' : 'AI Mentor'}</span>
      </div>
      <div className="messageBubble">
        {isOwn ? (
          <div className="userMessageText">{message.content}</div>
        ) : (
          <ReactMarkdown
            remarkPlugins={[remarkGfm]}
            components={{
              code({node, inline, className, children, ...props}) {
                const match = /language-(\w+)/.exec(className || '');
                const codeString = String(children).replace(/\\n$/, '');
                
                return !inline && match ? (
                  <div className="codeBlockWrapper">
                    <div className="codeBlockHeader">
                      <span className="codeBlockLang">{match[1]}</span>
                      <button 
                        className="copyCodeBtn" 
                        onClick={() => copyToClipboard(codeString)}
                        title="Copy Code"
                      >
                        <MdContentCopy size={14} /> Copy Code
                      </button>
                    </div>
                    <SyntaxHighlighter
                      style={vscDarkPlus}
                      language={match[1]}
                      PreTag="div"
                      customStyle={{ margin: 0, borderTopLeftRadius: 0, borderTopRightRadius: 0 }}
                      {...props}
                    >
                      {codeString}
                    </SyntaxHighlighter>
                  </div>
                ) : (
                  <code className={className} {...props}>
                    {children}
                  </code>
                );
              }
            }}
          >
            {message.content}
          </ReactMarkdown>
        )}
      </div>
    </div>
  );
};

export default ChatMessage;
